import { combineReducers } from "redux";
import crumbsReducer from "./crumbs/crumbs.reducer";
import dataAssetReducer from "./dataAsset/dataAsset.reducer";
import dataAssetsReducer from "./dataAssets/dataAssets.reducer";
import homeReducer from "./home/home.reducer";
import dataDomainReducer from "./dataDomain/dataDomain.reducer";
import subDomainReducer from "./dataSubDomain/dataSubDomain.reducer";
import AlertReducer from "./alert/alert.reducer";
import AccessManagementReducer from "./accessManagement/accessManagement.reducer";
import onboardingReducer from "./onboarding/onboarding.reducer";

export default combineReducers({
home:homeReducer,
crumbs:crumbsReducer,
dataAssets:dataAssetsReducer,
dataAsset:dataAssetReducer,
dataDomain:dataDomainReducer,
subDomain:subDomainReducer,
alert:AlertReducer,
accessManagement:AccessManagementReducer,
onboarding:onboardingReducer
});
   